import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const postCreateEmailUserAlias: DocumentNode = gql`
  mutation PostCreateEmailUserAlias($userAlias: EmailUserAlias) {
    createEmailUserAlias(input: { userAliases: [$userAlias] }) {
      aliasesProcessed
      message
    }
  }
`

export default postCreateEmailUserAlias
